import { Link } from 'react-router-dom';
import { allCourses } from '@/mocks/data';

export default function FeaturedCourses() {
  const featured = allCourses.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
              精选课程推荐
            </h2>
            <p className="text-foreground-600 text-base">严选优质课程，助你快速提升职场竞争力</p>
          </div>
          <Link
            to="/category/it-programming"
            className="hidden sm:inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((course) => (
            <Link
              key={course.id}
              to={`/article/${course.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                  {course.level}
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {course.title}
                </h3>
                <p className="text-foreground-600 text-sm line-clamp-2 mb-4 leading-relaxed">{course.description}</p>

                <div className="flex items-center gap-4 text-xs text-foreground-500 mb-4">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {course.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i> {course.students.toLocaleString()}人
                  </span>
                  <span className="flex items-center gap-1 text-primary-600">
                    <i className="ri-star-fill"></i> {course.rating}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-background-100">
                  <div className="flex items-baseline gap-2">
                    <span className="text-xl font-bold text-primary-600">¥{course.price}</span>
                    <span className="text-sm text-foreground-400 line-through">¥{course.originalPrice}</span>
                  </div>
                  <span className="text-xs text-foreground-500">{course.instructor}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10 sm:hidden">
          <Link
            to="/category/it-programming"
            className="inline-flex items-center gap-1 text-primary-600 font-medium text-sm"
          >
            查看全部课程 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}